<template>
  <!-- <div class="btnWrap">
    <div class="switch-wrapper">
      <label class="switch">
        <input
          :checked="modelValue"
          @change="emitChange($event)"
          type="checkbox"
        />
        <span class="slider"></span>
      </label>
    </div>
  </div> -->
  <!-- :class="{ dark: modelValue }"  -->
  <div class="body" :class="{ dark: !modelValue }">
    <label class="switch" for="switch">
      <input
        id="switch"
        :checked="modelValue"
        type="checkbox"
        @change="emitChange($event)"
      />
      <div class="sunmoon">
        <div class="darkside"></div>
      </div>
      <div class="border"></div>
      <div class="clouds">
        <img src="./cloud_1.svg" alt="" class="cloud cloud-1" />
        <img src="./cloud_2.svg" alt="" class="cloud cloud-2" />
        <img src="./cloud_3.svg" alt="" class="cloud cloud-3" />
        <img src="./cloud_4.svg" alt="" class="cloud cloud-4" />
        <img src="./stars.svg" alt="" class="stars" />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "SwitchTheme",
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },

    editable: {
      required: false,
      default: true,
    },
  },
  emits: ["update:modelValue", "changeValue"],
  setup(props, { emit }) {
    function emitChange(e) {
      //   const divBody = document.querySelector(".body");
      //   if (e.target.checked) {
      //     divBody.classList.add("dark");
      //   } else {
      //     divBody.classList.remove("dark");
      //   }
      emit("update:modelValue", e.target.checked);
    }
    // function emitChangeValue(e) {
    //   emit("changeValue", e.target.checked);
    // }

    return {
      emitChange,
    };
  },
};
</script>
<style lang="scss" scoped>
$bg-color: #cde7ff;
$switch-width: 65px; //150px;
$switch-height: 28px; //65px;
$switch-round: 20px; // 50px;
$switch-padding-x: 3px; //5px;
$switch-bg: linear-gradient(to bottom, #73bbff, #a2d1fd);
$switch-dark-bg: linear-gradient(to top, #2b3347, #181d27);
$border-width: 2px;
$border-gradient: linear-gradient(to bottom, #a2d1fd, #cde7ff);
$border-dark-gradient: linear-gradient(to bottom, #000000, #6c7384);
$sunmoon-size: 25px; // 55px;
$transition: all 0.5s ease;

.body {
  //   min-height: 100vh;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;

  transition: background-color 0.5s ease;
}

.switch {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: $switch-width;
  height: $switch-height;
  border-radius: $switch-round;
  cursor: pointer;
  transition: $transition;
  background: $switch-bg;
}

.switch::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: $switch-round;
  opacity: 0;
  background: $switch-dark-bg;
  transition: $transition;
}

.body.dark .switch::before {
  opacity: 1;
}

.switch .border {
  // position: absolute;
  // top: calc($border-width * -1);
  // left: calc($border-width * -1);
  // width: calc(100% + $border-width * 2);
  // height: calc(100% + $border-width * 2);
  // border-radius: $switch-round;
  // background: $border-gradient;
  // z-index: -1;
  // transition: $transition;
}

.switch .border::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: $switch-round;
  background: $border-dark-gradient;
  opacity: 0;
  transition: $transition;
}

.body.dark .switch .border::after {
  opacity: 1;
}

.switch input {
  display: none;
}

.sunmoon {
  position: absolute;
  width: $sunmoon-size;
  height: $sunmoon-size;
  border-radius: 50%;
  transition: $transition;
  left: $switch-padding-x;
  z-index: 1;
  background-color: #ffc187;
  box-shadow: 0px 0px 11.7px 0px #ffc187, 0px 0px 20px 0px #ffc18768,
    -2px -2px 5px 0px #ffab5c inset;
  transform: rotate(-125deg);
}

.body.dark .sunmoon {
  left: calc(100% - $sunmoon-size - $switch-padding-x);
  background-color: #dee5f3;
  box-shadow: 0px 0px 51.7px 0px #dee5f3;
  transform: rotate(0deg);
}

.darkside {
  position: absolute;
  top: 1px;
  left: 1px;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  background-color: #ffc187;
  transition: $transition;
}

.body.dark .darkside {
  background-color: #565c6b;
}

.clouds {
  border-radius: $switch-round;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.cloud {
  position: absolute;
  width: 60%;
  transition: $transition;
}

.cloud-1 {
  bottom: -55%;
  left: 0;
}

.cloud-2 {
  bottom: -45%;
  left: 25px;
}

.cloud-3 {
  bottom: -40%;
  right: 0px;
}

.cloud-4 {
  bottom: -16%;
  right: -25px;
}

.body.dark .cloud-1 {
  bottom: -35%;
  left: -110px;
}

.body.dark .cloud-2 {
  bottom: -15%;
  left: -110px;
  transition: all 0.7s ease;
}

.body.dark .cloud-3 {
  bottom: -15%;
  right: -110px;
}

.body.dark .cloud-4 {
  bottom: -5%;
  right: -110px;
  transition: all 0.7s ease;
}

.stars {
  position: absolute;
  top: 150%;
  left: 0;
  transform: translateY(-50%);
  pointer-events: none;
  transition: $transition;
}

.body.dark .stars {
  top: 50%;
}
</style>
